module.exports = __webpack_public_path__ + "static/flag-cdeac4ad2d401a6bbb6459d3303dc6e2.jpg";